import { render, staticRenderFns } from "./AllCollectionLeaderTask.vue?vue&type=template&id=c6387802&scoped=true&"
import script from "./AllCollectionLeaderTask.vue?vue&type=script&lang=js&"
export * from "./AllCollectionLeaderTask.vue?vue&type=script&lang=js&"
import style0 from "./AllCollectionLeaderTask.vue?vue&type=style&index=0&id=c6387802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6387802",
  null
  
)

export default component.exports